(function () {
  'use strict';
  var root = (document.documentElement.getAttribute('data-runit-media-root') || '/apps/runit').replace(/\/$/, '');
  function cleanUrl(value) {
    try {
      var url = new URL(value, location.href), path = url.pathname;
      if (!/\.(png|jpe?g|webp)$/i.test(path)) return value;
      if (url.hostname === 'runitlondon.co.uk' && /^\/cdn\/shop\/(files|collections|products|t)\//.test(path)) {
        return root + '/media/' + path.slice('/cdn/'.length) + '/image' + url.search;
      }
      if (url.hostname === 'cdn.shopify.com' && path.indexOf('/s/files/1/0865/3576/6365/') === 0) {
        return root + '/media/' + path.slice('/s/'.length) + '/image' + url.search;
      }
    } catch (e) { /* A non-URL attribute stays unchanged. */ }
    return value;
  }
  function cleanSet(value) {
    return value.split(',').map(function (part) {
      return part.trim().split(/\s+/).map(function (bit, index) { return index ? bit : cleanUrl(bit); }).join(' ');
    }).join(', ');
  }
  // Own JavaScript and app widgets assigning image attributes use the same route
  // before the browser starts a new fetch. Other elements/attributes are untouched.
  var setAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    if (/^(IMG|SOURCE)$/.test(this.tagName) && /^(src|srcset)$/i.test(name) && typeof value === 'string') {
      value = name.toLowerCase() === 'srcset' ? cleanSet(value) : cleanUrl(value);
    }
    return setAttribute.call(this, name, value);
  };
  function wrap(prototype, name, convert) {
    var descriptor = Object.getOwnPropertyDescriptor(prototype, name);
    if (!descriptor || !descriptor.configurable || !descriptor.set) return;
    Object.defineProperty(prototype, name, {
      configurable: descriptor.configurable, enumerable: descriptor.enumerable, get: descriptor.get,
      set: function (value) { descriptor.set.call(this, convert(String(value))); }
    });
  }
  wrap(HTMLImageElement.prototype, 'src', cleanUrl);
  wrap(HTMLImageElement.prototype, 'srcset', cleanSet);
  wrap(HTMLSourceElement.prototype, 'srcset', cleanSet);
  function rewrite(node) {
    if (node.nodeType !== 1) return;
    var images = /^(IMG|SOURCE)$/.test(node.tagName) ? [node] : [];
    images = images.concat(Array.from(node.querySelectorAll('img,source')));
    images.forEach(function (image) {
      ['src', 'srcset'].forEach(function (name) {
        var before = image.getAttribute(name);
        if (!before) return;
        var after = name === 'srcset' ? cleanSet(before) : cleanUrl(before);
        if (after !== before) setAttribute.call(image, name, after);
      });
    });
  }
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') rewrite(record.target);
      else record.addedNodes.forEach(rewrite);
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  rewrite(document.documentElement);
})();
